import { PayloadAction } from "@reduxjs/toolkit";
import { Epic, combineEpics, ofType } from "redux-observable";
import { combineLatestWith, distinct, map, scan, switchMap } from "rxjs/operators";
import { loadMainPage, LoadMainPagePayload, setMainMenu, setMainPageData } from "./appStateSlice";
import { RootState } from "redux/store";
import { selectContentBucket, selectMainMenu } from "./selectors";
import { asyncScheduler, forkJoin, scheduled } from "rxjs";
import { selectBlogger, selectUser } from "../user/selectors";
import { MainMenuItem } from "@model/app-state";
import { getMainPage } from "./main-page.data-provider";
import { websiteDomain } from "aws-website-config";
import { BlogMode } from "@model/blogger-state";

type loadMainPageState = {
  bucket?: string,
  bloggerMode?: boolean;
  mainMenu?: MainMenuItem[],
  blogModeState?: BlogMode,
  isPublishedBucket?: boolean
}
const loadMainPageEpic: Epic<PayloadAction<any>, PayloadAction<any>, RootState> =
  (action$, state$) => action$.pipe(
    ofType(loadMainPage.type),
    combineLatestWith(state$.pipe(
      map(state => ({
        bucket: selectContentBucket(state),
        bloggerMode: selectUser(state)?.isBlogger,
        mainMenu: selectMainMenu(state),
        blogModeState: selectBlogger(state)?.mode,
        isPublishedBucket: selectBlogger(state)?.publishedBucket === selectContentBucket(state) && selectContentBucket(state)
      }) as loadMainPageState),
      scan<loadMainPageState, loadMainPageState>((acc, st) => (acc.bucket != st.bucket || acc.bloggerMode !== st.bloggerMode) ? st : acc, {}),
      distinct()
    )),
    switchMap(([{ payload }, { bucket, bloggerMode, mainMenu, blogModeState, isPublishedBucket }]: [PayloadAction<LoadMainPagePayload>, loadMainPageState]) => {
      return forkJoin([getMainPage(bloggerMode, isPublishedBucket ? undefined : bucket, undefined, undefined, websiteDomain, blogModeState),
        getMainPage(bloggerMode, isPublishedBucket ? undefined : bucket, mainMenu, payload.page, websiteDomain, blogModeState)],
      (root, current) => ({ ...current, mainMenu: root.mainMenu }) );

    }),
    switchMap(({ posts, blogs, mainMenu }) => {
      const mainMenuAction = mainMenu ? [setMainMenu({ mainMenu })] : [];
      return scheduled([setMainPageData({
        posts,
        blogs
      }), ...mainMenuAction], asyncScheduler);
    })
)


export const appEpic = combineEpics(loadMainPageEpic);